import { Tooltip } from '@material-ui/core'
import React, { Component, Fragment } from 'react'

export default class SkillItem extends Component {
    render() {
        return (
            <Fragment>
                <div className="col-lg-6 col-md-6 rounded-sm col-sm-12 col-12 py-3" style={{}}>
                    <h6 className="text-lato" style={{color: this.props.mode?"white":"black"}}>{this.props.text}</h6>
                    <div className="container-fluid p-0 rounded-pill" style={{height:10,backgroundColor:this.props.mode?"rgba(255,255,255,0.03)":"rgba(0,0,0,0.2)"}}>
                        <Tooltip placement="bottom-end" arrow title={this.props.width}>
                            <span className="d-block rounded-pill" style={{backgroundColor:"red",height:10,width:this.props.width}}></span>
                        </Tooltip>
                    </div>
                </div>
            </Fragment>
        )
    }
}
